<template>
  <div>
    <div v-show="cargando">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-show="!cargando">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cargando: true,
    };
  },
  methods: {
    empezar() {
      this.cargando = true;
    },
    parar() {
      this.cargando = false;
    },
  },
};
</script>